import { useDispatch, useSelector, useStore } from "react-redux";
import type { AppDispatch, AppStore, RootState } from "./store";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();

/** Show full-page loader only when there is no cached data yet. */
export function useShowInitialLoader(
  isLoading: boolean,
  data: unknown,
): boolean {
  return isLoading && data === undefined;
}
